<template>
  <div class="home">
    <LeafAngle msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
// @ is an alias to /src
import LeafAngle from '@/components/LeafAngle.vue'

export default {
  name: 'HomeView',
  components: {
    LeafAngle
  }
}
</script>
